// import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';

let appObject = {
    page_loader: false,
    popup_loader: false,
    menuExpanded: 0,
    agents: [],
    settings: {},

    escapeEventHandlers: [],

    edit_user: null,
    callbackFunction: null,
};

const {get, set, update, subscribe} = writable(appObject);

const app = {
    set,
    update,
    subscribe,

    showPageLoader: () => {
        app.update(obj => {
            obj.page_loader = true;
            return obj;
        });
    },
    hidePageLoader: () => {
        // setTimeout(function () {
        app.update(obj => {
            obj.page_loader = false;
            return obj;
        });
        // }, 500);
    },
    showPopupLoader: () => {
        app.update(obj => {
            obj.popup_loader = true;
            return obj;
        });
    },
    hidePopupLoader: () => {
        app.update(obj => {
            obj.popup_loader = false;
            return obj;
        });
    },

    windowResize: () => {
        app.update(obj => {
            let win = window,
                doc = document,
                docElem = doc.documentElement,
                body = doc.getElementsByTagName('body')[0];

            obj.docWidth = win.innerWidth || docElem.clientWidth || body.clientWidth,
            obj.docHeight = win.innerHeight|| docElem.clientHeight|| body.clientHeight;

            if (obj.docWidth > 1199) {
                obj.device = "lg";
            } else if (obj.docWidth > 991) {
                obj.device = "md";
            } else if (obj.docWidth > 767) {
                obj.device = "sm";
            } else {
                obj.device = "xs";
            }

            return obj;
        });
    },

    addEscapeEventHandler: handler => {
        app.update(storeObj => {
            storeObj.escapeEventHandlers = [...storeObj.escapeEventHandlers, handler];
            return storeObj;
        });
    },
    removeEscapeEventHandler: () => {
        app.update(storeObj => {
            if (storeObj.escapeEventHandlers.length) {
                storeObj.escapeEventHandlers = storeObj.escapeEventHandlers.slice(0, -1);
            }
            return storeObj;
        });
    },

    getSiteUrl: () => {
        return appObject.site_url;
    },

    setAgents: (agents) => {
        app.update(storeObj => {
            storeObj.agents = agents;
            return storeObj;
        });
    },

    setSettings: (settings) => {
        app.update(storeObj => {
            settings.max_cruise_persons = ~~settings.max_cruise_persons;
            storeObj.settings = settings;
            return storeObj;
        });
    },

    editUser: (data, callbackFunction = null) => {
        app.update(storeObj => {
            storeObj.edit_user = data;
            storeObj.callbackFunction = callbackFunction;

            return storeObj;
        });
    },
    clearEditUser: () => {
        app.update(storeObj => {
            storeObj.edit_user = null;
            storeObj.callbackFunction = null;

            return storeObj;
        });
    }
}

export default app;